function ListFourImagesMobileScroll({
  image1,
  image2,
  image3,
  image4,
  className,
}: any) {
  const images = [image1, image2, image3, image4];

  return (
    <div className={`flex overflow-x-auto space-x-4 pt-4 scrollbar-hide ${className}`}>
      {images.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Image ${index + 1}`}
          className=" w-[130px] object-cover flex-shrink-0 rounded-lg "
        />
      ))}
    </div>
  );
}

export default ListFourImagesMobileScroll;
